import { spacing } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled, { css } from "styled-components";
import { px } from "../../../mixins/formatters";
import Box from "../../Box";
import { selectBoxDefaultProps } from "../config";
export const OptionContainer = styled(Box) `
  display: grid;

  ${({ minOptionWidth = selectBoxDefaultProps.minOptionWidth }) => css `
    grid-template-columns: repeat(auto-fit, minmax(${px(minOptionWidth)}, 1fr));
  `}

  &.withGap {
    grid-gap: ${spacing.base.m};
  }

  &.flexMode {
    display: flex;
    flex-direction: row;
  }

  &.compact {
    & {
      display: flex;
      flex-direction: column;
      align-items: unset;
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3B0aW9uQ29udGFpbmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvU2VsZWN0Qm94L3N0eWxlZC9PcHRpb25Db250YWluZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLE9BQU8sRUFBRSxNQUFNLGdEQUFnRCxDQUFDO0FBQ3pFLE9BQU8sTUFBTSxFQUFFLEVBQUUsR0FBRyxFQUFFLE1BQU0sbUJBQW1CLENBQUM7QUFDaEQsT0FBTyxFQUFFLEVBQUUsRUFBRSxNQUFNLDRCQUE0QixDQUFDO0FBQ2hELE9BQU8sR0FBRyxNQUFNLFdBQVcsQ0FBQztBQUM1QixPQUFPLEVBQUUscUJBQXFCLEVBQUUsTUFBTSxXQUFXLENBQUM7QUFHbEQsTUFBTSxDQUFDLE1BQU0sZUFBZSxHQUFHLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBc0I7OztJQUc1RCxDQUFDLEVBQUUsY0FBYyxHQUFHLHFCQUFxQixDQUFDLGNBQWMsRUFBRSxFQUFFLEVBQUUsQ0FBQyxHQUFHLENBQUE7cURBQ2pCLEVBQUUsQ0FBQyxjQUFjLENBQUM7R0FDcEU7OztnQkFHYSxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7Ozs7Ozs7Ozs7Ozs7OztDQWU3QixDQUFDIn0=